import { useCallback } from 'react';

import { useAnalyticsUtilities } from '../hooks/useAnalyticsUtilities';
import META from './useTrackToggledContentCollectionFormAutoSubmitOff.meta';

export type TrackToggledContentCollectionFormAutoSubmitOffParams = {
  form_id: string;
};

export const useTrackToggledContentCollectionFormAutoSubmitOff = () => {
  const { track } = useAnalyticsUtilities();

  const trackToggledContentCollectionFormAutoSubmitOff = useCallback(
    (params: TrackToggledContentCollectionFormAutoSubmitOffParams) => {
      track(META.name, params);
    },
    [track],
  );

  return {
    trackToggledContentCollectionFormAutoSubmitOff,
  };
};
